export default[
    {
        path: '/aplicativo/lista',
        name: 'lista do aplicativo', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/aplicativo/cadastro',
        name: 'cadastro do aplicativo', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/aplicativo/editar/:id',
        name: 'editar aplicativo', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]